import { render, staticRenderFns } from "./StarterFooter.vue?vue&type=template&id=a8adac78"
import script from "./StarterFooter.vue?vue&type=script&lang=js"
export * from "./StarterFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports